import { Link } from 'react-router-dom';
import { EmptyState } from '../components/ui';

export default function NotFound() {
  return (
    <EmptyState
      glyph="∅"
      title="Page not found"
      body="The page you were looking for is not here. It may have been moved or hidden."
      action={
        <Link className="btn btn-dark" to="/">
          Back to chapters
        </Link>
      }
    />
  );
}
